const img = (id, w = 1600) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;

export const COMPANY = {
  name: "Sunny's Construction Ltd",
  number: "16897823",
  phone: "+44 7716 314150",
  phoneHref: "tel:+447716314150",
  email: "enquiries@sunnysconstruction.com",
  office: "18 Alderwick Drive, Hounslow, England, TW3 1SF",
  hours: "Mon – Sat, 8:00 – 18:00",
};

export const IMAGES = {
  hero: img(28556623, 2000),
  about: img(8961260, 1400),
};

export const SERVICES = [
  {
    n: "01",
    icon: "Home",
    title: "Loft Conversion",
    desc: "Dormer, hip-to-gable and Velux loft conversions that turn unused roof space into bright, fully compliant bedrooms, offices and studios.",
    img: img(20290907, 1200),
  },
  {
    n: "02",
    icon: "Expand",
    title: "Extensions",
    desc: "Single and double-storey rear and side extensions — from foundations to finishes, with structural steels, glazing and seamless joins to your existing home.",
    img: img(28885519, 1200),
  },
  {
    n: "03",
    icon: "Zap",
    title: "Electrical",
    desc: "Full and partial rewires, consumer unit upgrades, lighting design and certification by qualified electricians — every job tested and signed off.",
    img: img(5691588, 1200),
  },
  {
    n: "04",
    icon: "Wrench",
    title: "Plumbing",
    desc: "Complete first and second fix plumbing: bathrooms, kitchens, heating pipework, radiators and hot water systems, installed neatly and built to last.",
    img: img(6419128, 1200),
  },
  {
    n: "05",
    icon: "Layers",
    title: "Roofing",
    desc: "Re-roofs, tile and slate replacement, flat roof membranes, repairs and guttering — weather-tight workmanship backed by long guarantees.",
    img: img(31763541, 1200),
  },
  {
    n: "06",
    icon: "UtensilsCrossed",
    title: "Kitchen",
    desc: "Bespoke kitchen renovations from strip-out to final fit: cabinetry, worktops, tiling, lighting and appliances, project-managed end to end.",
    img: img(33257996, 1200),
  },
  {
    n: "07",
    icon: "Bath",
    title: "Bathroom",
    desc: "Full bathroom renovations including wet rooms and en-suites — waterproofing, tiling, sanitaryware and underfloor heating, finished to a high spec.",
    img: img(7045908, 1200),
  },
];

export const PROJECTS = [
  {
    slug: "hounslow-rear-extension",
    title: "Hounslow Single-Storey Rear Extension",
    location: "Hounslow, London",
    service: "Extensions",
    year: "2026",
    duration: "10 weeks",
    desc: "A red-brick rear extension in Hounslow with uPVC glazing, exterior wall lights and an LED-edged composite deck.",
    img: "/projects/hounslow-extension.jpg",
    video: "https://customer-assets-lqy194kg.emergentagent.net/job_build-sunny/artifacts/0a130k1t_WhatsApp%20Video%202026-08-24%20at%2017.25.13.mp4",
    overview:
      "The owners of this Hounslow home needed more ground-floor living space without losing the garden. We built a single-storey rear extension in matching red brick, fitted energy-efficient uPVC windows and a glazed rear door, and finished outside with a low-maintenance composite deck edged in LED lighting and warm exterior wall lights. The result is a bright new living space that blends seamlessly with the existing house.",
    scope: [
      "Foundations, drainage and structural brickwork",
      "uPVC windows and glazed rear door installation",
      "Roof structure with soffit downlights",
      "Composite decking with LED edge lighting",
      "Exterior lighting, electrics and certification",
    ],
  },
  {
    slug: "ilford-garden-room",
    title: "Ilford Bespoke Garden Room & Decking",
    location: "Ilford, London",
    service: "Garden Rooms",
    year: "2026",
    duration: "6 weeks",
    desc: "A fully insulated garden room in Ilford with a tiled roof, oak-post veranda, French doors and integrated deck lighting.",
    img: "/projects/ilford-garden-room.jpg",
    video: "https://customer-assets-lqy194kg.emergentagent.net/job_build-sunny/artifacts/m0quvdpu_WhatsApp%20Video%202026-08-24%20at%2017.24.28.mp4",
    overview:
      "This Ilford garden now works all year round. We designed and built a fully insulated garden room with a traditional tiled roof and oak-post veranda, oak-effect French doors and windows, and warm exterior lighting throughout. Integrated deck lights and a wide timber deck turn it into an evening-ready outdoor living space — ideal as a home office, gym or guest room.",
    scope: [
      "Insulated timber-frame garden room construction",
      "Tiled pitched roof with fascias and guttering",
      "Oak-effect French doors and windows",
      "Timber veranda and decking with LED lighting",
      "Electrics, exterior lighting and interior finish",
    ],
  },
  {
    slug: "langley-media-wall",
    title: "Langley Media Wall & Living Room Renovation",
    location: "Langley, Slough",
    service: "Interior Renovation",
    year: "2026",
    duration: "4 weeks",
    desc: "A feature media wall in Langley with LED-lit display niches, stone-effect cladding, bespoke cabinetry and oak-effect flooring.",
    img: "/projects/langley-media-wall.jpg",
    video: "https://customer-assets-lqy194kg.emergentagent.net/job_build-sunny/artifacts/avtbbi7c_WhatsApp%20Video%202026-08-24%20at%2017.26.11.mp4",
    overview:
      "The brief for this Langley living room was a centrepiece. We designed and built a bespoke media wall with LED-lit display niches, stone-effect split-face cladding, a recessed electric fire and floating console cabinetry with marble-effect worktops. New track and feature lighting complete a room that now feels like a showroom.",
    scope: [
      "Bespoke media wall design and construction",
      "LED-lit display niches and recessed electric fire",
      "Stone-effect split-face feature wall cladding",
      "Custom cabinetry with marble-effect worktops",
      "Track lighting, electrics and full decoration",
    ],
  },
  {
    slug: "hayes-house-renovation",
    title: "Hayes Full House Renovation",
    location: "Hayes, London",
    service: "Full Renovation",
    year: "2025",
    duration: "16 weeks",
    desc: "A complete house renovation in Hayes — strip-out, rewire, replumb, plastering and decoration to a turnkey finish.",
    img: "/projects/sunbury-avenue-renovation.jpg",
    video: "https://customer-assets-lqy194kg.emergentagent.net/job_build-sunny/artifacts/4p8t4ip7_WhatsApp%20Video%202026-08-24%20at%2017.23.39.mp4",
    overview:
      "A full strip-out and renovation of this Hayes home, delivered turnkey. Our in-house team handled the rewire, replumb, plastering, kitchen and bathroom refits and full decoration — one project manager, one programme, no chasing trades. The property was handed back modern, efficient and ready to move into.",
    scope: [
      "Full strip-out and waste removal",
      "Complete rewire and consumer unit upgrade",
      "Replumb and heating improvements",
      "Plastering, kitchen and bathroom refits",
      "Flooring, joinery and full decoration",
    ],
  },
  {
    slug: "hounslow-kitchen-renovation",
    title: "Hounslow Kitchen Extension & Renovation",
    location: "Hounslow, London",
    service: "Kitchen",
    year: "2026",
    duration: "6 weeks",
    desc: "A light-filled kitchen renovation in Hounslow with roof lanterns, handle-less grey cabinetry and marble-effect porcelain floors.",
    img: "/projects/hounslow-kitchen.jpg",
    video: "https://customer-assets-lqy194kg.emergentagent.net/job_build-sunny/artifacts/in9nz1e4_WhatsApp%20Video%202026-08-24%20at%2017.23.53.mp4",
    overview:
      "This Hounslow kitchen extension maximises natural light with twin roof lanterns and a full wall of glazing to the garden. We installed handle-less dove-grey cabinetry, white stone worktops, marble-effect porcelain flooring and integrated appliances — with all plumbing and electrics completed by our own in-house team.",
    scope: [
      "Kitchen strip-out and first fix",
      "Twin roof lanterns and garden-facing glazing",
      "Handle-less cabinetry and white stone worktops",
      "Marble-effect porcelain floor tiling",
      "Integrated appliances, plumbing and electrics",
    ],
  },
  {
    slug: "sunbury-avenue-renovation",
    title: "The Avenue Whole-House Transformation, Sunbury",
    location: "Sunbury-on-Thames",
    service: "Full Renovation",
    year: "2025",
    duration: "20 weeks",
    desc: "A whole-house renovation on The Avenue, Sunbury — fresh white render, anthracite windows, new roofline and statement metal gates.",
    img: "/projects/sunbury-avenue-renovation.jpg",
    video: "https://customer-assets-lqy194kg.emergentagent.net/job_build-sunny/artifacts/0a130k1t_WhatsApp%20Video%202026-08-24%20at%2017.25.13.mp4",
    overview:
      "A complete exterior and interior transformation on The Avenue, Sunbury. The house was re-rendered in crisp white, fitted with anthracite-framed windows and dark double doors, and finished with a refreshed roofline and bespoke black metal gates. Inside, the renovation delivered modern, open living spaces throughout — a total kerb-to-kitchen rebuild.",
    scope: [
      "External re-render and masonry repairs",
      "Anthracite window and door replacements",
      "Roofline, fascias and guttering",
      "Bespoke metal gates and driveway works",
      "Full interior renovation and decoration",
    ],
  },
];

export const STATS = [
  { value: 19, suffix: "+", label: "Years Experience" },
  { value: 120, suffix: "+", label: "Projects Delivered" },
  { value: 100, suffix: "%", label: "Insured Workmanship" },
];

export const SERVICE_OPTIONS = [
  "Loft Conversion",
  "Extension",
  "Kitchen Renovation",
  "Bathroom Renovation",
  "Roofing",
  "Electrical",
  "Plumbing",
  "Full Renovation",
  "Other",
];

export const VIDEOS = [
  {
    title: "Recent Site Walkthrough",
    tag: "Site Film 01",
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_build-sunny/artifacts/0a130k1t_WhatsApp%20Video%202026-08-24%20at%2017.25.13.mp4",
  },
  {
    title: "Work in Progress",
    tag: "Site Film 02",
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_build-sunny/artifacts/m0quvdpu_WhatsApp%20Video%202026-08-24%20at%2017.24.28.mp4",
  },
  {
    title: "On the Tools",
    tag: "Site Film 03",
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_build-sunny/artifacts/avtbbi7c_WhatsApp%20Video%202026-08-24%20at%2017.26.11.mp4",
  },
  {
    title: "Project Update",
    tag: "Site Film 04",
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_build-sunny/artifacts/4p8t4ip7_WhatsApp%20Video%202026-08-24%20at%2017.23.39.mp4",
  },
  {
    title: "The Finished Build",
    tag: "Site Film 05",
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_build-sunny/artifacts/in9nz1e4_WhatsApp%20Video%202026-08-24%20at%2017.23.53.mp4",
  },
];
